import React from 'react'
import {useStaticQuery, graphql} from 'gatsby'
import Card from '../Card'

const dataQuery = graphql`
  query {
    content: homepageJson {
      config {
        rapid {
          sections {
            listing
          }
        }
      }
      sections {
        extensions {
          h2
        }
      }
    }
  }
`

export default function Extensions({extensions}) {
  const {content} = useStaticQuery(dataQuery)

  return (
    <section className="py-4">
      <div className="container">
        <h2 className="text-center">{content.sections.extensions.h2}</h2>

        <div className="row justify-content-center">
          {extensions.map((extension, idx) => {
            const rapid = {
              sec: content.config.rapid.sections.listing,
              pos: idx + 1,
              ll1: extension.tag,
            }

            return <Card key={extension.id} extension={extension} rapid={rapid} />
          })}
        </div>
      </div>
    </section>
  )
}
